import { render, staticRenderFns } from "./campaignPlateTitle.vue?vue&type=template&id=35a6853c&scoped=true&"
import script from "./campaignPlateTitle.vue?vue&type=script&lang=js&"
export * from "./campaignPlateTitle.vue?vue&type=script&lang=js&"
import style0 from "./campaignPlateTitle.vue?vue&type=style&index=0&id=35a6853c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a6853c",
  null
  
)

export default component.exports